// extracted by mini-css-extract-plugin
export default {"icon":"Check_icon__22USj"};